import type { SVGProps } from "react";
import { memo } from "react";
const ElasticLoadBalancing = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 80 80" {...props}>
    <defs>
      <linearGradient id="prefix__a" x1="0%" x2="100%" y1="100%" y2="0%">
        <stop offset="0%" stopColor="#4D27A8" />
        <stop offset="100%" stopColor="#A166FF" />
      </linearGradient>
    </defs>
    <g fill="none" fillRule="evenodd">
      <path fill="url(#prefix__a)" d="M0 0h80v80H0z" />
      <path
        fill="#FFF"
        d="M30 53c-7.168 0-13-5.832-13-13s5.832-13 13-13 13 5.832 13 13-5.832 13-13 13m30 6c0 2.206-1.794 4-4 4s-4-1.794-4-4 1.794-4 4-4 4 1.794 4 4m-4-42c2.206 0 4 1.794 4 4s-1.794 4-4 4-4-1.794-4-4 1.794-4 4-4m3 19c2.206 0 4 1.794 4 4s-1.794 4-4 4-4-1.794-4-4 1.794-4 4-4m-14.051 5h8.141c.478 2.833 2.943 5 5.91 5 3.309 0 6-2.691 6-6s-2.691-6-6-6c-2.967 0-5.432 2.167-5.91 5h-8.141a14.9 14.9 0 0 0-1.377-5.346l8.874-7.831A5.96 5.96 0 0 0 56 27c3.309 0 6-2.691 6-6s-2.691-6-6-6-6 2.691-6 6c0 1.256.389 2.421 1.051 3.386l-8.47 7.473C39.904 27.738 35.271 25 30 25c-8.271 0-15 6.729-15 15s6.729 15 15 15c5.271 0 9.904-2.738 12.581-6.859l8.47 7.473A5.96 5.96 0 0 0 50 59c0 3.309 2.691 6 6 6s6-2.691 6-6-2.691-6-6-6a5.96 5.96 0 0 0-3.554 1.177l-8.874-7.831A14.9 14.9 0 0 0 44.949 41"
      />
    </g>
  </svg>
);
const Memo = memo(ElasticLoadBalancing);
export default Memo;
